import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,  Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
// import { requestRegions, requestProvincias} from '../../actions/params'
import { getTiendaByCliente } from '../../actions/datoscliente';
import MyUserService from "../../services/myUser";
import colores from '../../shared/constants/styles';
import { ContactoRequest } from './iMisDatos';
import { IContactos } from './iMisDatos';

interface ContactoDialogDialogProps {
    open: boolean;
    onClose: () => void;
    onGuardar: (request: ContactoRequest) => void;
    // regions: any | null;
    // provincias: any| null;
    tiendas: any| null;
    contacto?: IContactos;
}

const ContactoDialog = (props: ContactoDialogDialogProps) => {
    // const [regionId, setRegionId] = useState("");
    // const [provinciaId, setProvinciaId] = useState("");

    const [nombre, setNombre] = useState("");
    const [email, setEmail] = useState("");
    const [telefono, setTelefono] = useState("");
    const [tiendaId, setTiendaId] = useState("");
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    let contactoRequest: ContactoRequest = {
        nombre,
        email,
        telefono,
        tiendaId,
        visible: true
    };
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getTiendaByCliente(MyUserService.getMyUser().clienteId));
    }, []);

    useEffect(() => {
        if (props.contacto) {
            setNombre(props.contacto.nombre);
            setEmail(props.contacto.email);
            setTelefono(props.contacto.telefono);
            setTiendaId(props.contacto.tiendaId);
        } else {
            setNombre("");
            setEmail("");
            setTelefono("");
            setTiendaId("");
        }
    }, [props.contacto, props.open]);

    const handleSubmit = () => {
        let valid = true;
        const newErrors: any = {};
        const trimmedEmail = email.trim(); 

        if (!nombre.trim()) {
            newErrors.nombre = "El nombre es obligatorio.";
            valid = false;
        }
        if (!trimmedEmail) {
            newErrors.email = "El email es obligatorio.";
            valid = false;
        } else if (!isValidEmail(trimmedEmail)) {
            newErrors.email = "El formato del email no es válido.";
            valid = false;
        }
        if (!tiendaId) {
            newErrors.tiendaId = "La tienda es obligatoria.";
            valid = false;
        }
        
        setErrors(newErrors);
        if (!valid) return;   
        
        
        let tienda= props.tiendas?.$values.find((t:any)=> t.id ==tiendaId);
        
        contactoRequest = {
            ...props.contacto,
            nombre,
            telefono,
            tiendaNro: tienda?.tiendaNro,
            email: trimmedEmail,
            tiendaId,
            visible: true
        };     
        props.onGuardar(contactoRequest);
    };

    const isValidEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    return (
        <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm">
            <DialogTitle>{props.contacto ? "Editar Correo" : "Crear Correo"}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Nombre"
                    fullWidth
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    margin="normal"
                    error={Boolean(errors.nombre)}
                    helperText={errors.nombre}
                /> 
                <TextField
                    label="Email"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    margin="normal"
                    error={Boolean(errors.email)}
                    helperText={errors.email}
                />  
                <TextField
                    label="Teléfono"
                    fullWidth
                    value={telefono}
                    onChange={(e) => setTelefono(e.target.value)}
                    margin="normal"
                    error={Boolean(errors.telefono)}
                    helperText={errors.telefono}
                />   
                <FormControl fullWidth margin="normal" disabled={props.contacto?.contactoId ? props.contacto?.contactoId > 0: false}>
                    <InputLabel id="tienda-label">Tienda</InputLabel>
                    <Select
                        labelId="tienda-label"
                        value={tiendaId}
                        label="Tienda"
                        onChange={(e) => setTiendaId(e.target.value)}
                    >
                        {props.tiendas?.$values?.map((tienda: any) => (
                            <MenuItem key={tienda.id.toString()} value={tienda.id.toString()}>
                                {tienda.tiendaNro}- {tienda.calle} {tienda.calleNro}
                            </MenuItem>
                        ))}
                    </Select>
                    {Boolean(errors.tiendaId) && <FormHelperText sx={{ color: 'error.main' }}>{errors.tiendaId}</FormHelperText>}
                </FormControl>                         
                {/* <FormControl fullWidth margin="normal">
                    <InputLabel id="region-label">Región</InputLabel>
                    <Select
                        labelId="region-label"
                        value={regionId}
                        label="Región"
                        onChange={(e) => setRegionId(e.target.value)}
                    >
                        {props.regions?.$values?.map((region: any) => (
                            <MenuItem key={region.id} value={region.id}>
                                {region.descripcion}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <InputLabel id="provincia-label">Provincia</InputLabel>
                    <Select
                        labelId="provincia-label"
                        value={provinciaId}
                        label="Provincia"
                        onChange={(e) => setProvinciaId(e.target.value)}
                    >
                        {props.provincias?.$values?.map((provincia: any) => (
                            <MenuItem key={provincia.id} value={provincia.id}>
                                {provincia.descripcion}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>  */}
            </DialogContent>
            <DialogActions>
                <button 
                    type="submit" 
                    style={{background: colores.grisOscuro, color: 'white'}} className="btn" onClick={props.onClose}>
                    Cancelar
                </button>
                <button 
                    type="submit" 
                    style={{background: colores.rojo, color: 'white'}} className="btn" onClick={handleSubmit}>
                    {props.contacto ? "Actualizar" : "Crear"}
                </button>
            </DialogActions>
        </Dialog>
    );
};
export default connect
(
    (state: any) => ({
        // regions: state.params.regions,
        // provincias: state.params.provincias,
        tiendas: state.datoscliente.tiendas,
        state: state
    }),
    dispatch => ({
        getTiendaByCliente: (clienteId: string) => dispatch(getTiendaByCliente(clienteId))
        // requestRegions:() => dispatch(requestRegions()),
        // requestProvincias:() => dispatch(requestProvincias())
    })
)(ContactoDialog);
